import React, { useState, useEffect } from 'react';
import {IonPage,IonHeader,IonToolbar,IonButtons,IonButton,IonMenuButton,IonTitle, IonContent, IonGrid, IonRow, IonCol, IonText } from '@ionic/react';
import Control from '../components/Control';
import ControlFE from '../components/ControlFE';
import Resultado from '../components/Resultado';


const Calculo = (props) => {
    const [hideparams, setHideparams] = useState(0);
    const [result, setResult] = useState(21);
    const [params, setParams] = useState({
      numfe: 40,
      numtas: 120,
      numfc: 80,
      numtfg: 50,
      numk: 5,
      fe: 1,
      tas: 2,
      fc: 2,
      tfg: 3,
      k: 1,
    });
    useEffect(() => {
//      console.log('Result ' + result);
    }, [result])
    useEffect(() => {
//      console.log('Hide ' + hideparams);
    }, [hideparams])
    useEffect(() => {
      if (params.fe === 3) {
        setHideparams(1);
        if (params.tas === 1) {
          setResult(23);
        } else if (params.tas === 2) {
          setResult(24);
        }
      } else if (params.fe === 2) {
        setHideparams(1);
  
        if (params.tas === 1) {
          setResult(23);
        } else if (params.tas === 2) {
          setResult(24);
        }
      } else if (params.fe === 1) {
        setHideparams(0);
        if (params.tas === 1) {
          if (params.fc === 1) {
            if (params.tfg === 1) {
              setResult(1);
            } else if (params.tfg === 2) {
              if (params.k === 1) {
                setResult(2);
              } else if (params.k === 2) {
                setResult(3);
              }
            } else if (params.tfg === 3) {
              if (params.k === 1) {
                setResult(4);
              } else if (params.k === 2) {
                setResult(5);
              }
            }
          } else if (params.fc === 2) {
            if (params.tfg === 1) {
              setResult(6);
            } else if (params.tfg === 2) {
              if (params.k === 1) {
                setResult(7);
              } else if (params.k === 2) {
                setResult(8);
              }
            } else if (params.tfg === 3) {
              if (params.k === 1) {
                setResult(9);
              } else if (params.k === 2) {
                setResult(10);
              }
            }
          }
        } else if (params.tas === 2) {
          if (params.fc === 1) {
            if (params.tfg === 1) {
              if (params.k === 1) {
                setResult(11);
              } else if (params.k === 2) {
                setResult(12);
              }
            } else if (params.tfg === 2) {
              if (params.k === 1) {
                setResult(13);
              } else if (params.k === 2) {
                setResult(14);
              }
            } else if (params.tfg === 3) {
              if (params.k === 1) {
                setResult(15);
              } else if (params.k === 2) {
                setResult(16);
              }
            }
          } else if (params.fc === 2) {
            if (params.tfg === 1) {
              if (params.k === 1) {
                setResult(17);
              } else if (params.k === 2) {
                setResult(18);
              }
            } else if (params.tfg === 2) {
              if (params.k === 1) {
                setResult(19);
              } else if (params.k === 2) {
                setResult(20);
              }
            } else if (params.tfg === 3) {
              if (params.k === 1) {
                setResult(21);
              } else if (params.k === 2) {
                setResult(22);
              }
            }
          }
        }
      }
//      console.log(params);
  
    }, [params])
  
    const handleFE = (value) => {
  
      let valueproccesed = 0;
      if (value > 0 && value < 50) {
        valueproccesed = 1
      } else if (value < 101 && value >= 50) {
        valueproccesed = 2
      } else if (value > 100) {
        valueproccesed = 3
      }
      setParams({ ...params, fe: valueproccesed, numfe: value });
    };
  
    const handleTAS = (value) => {
  
      let valueproccesed = 0;
      if (value > 0 && value < 100) {
        valueproccesed = 1
      } else if (value >= 100) {
        valueproccesed = 2
      }
      setParams({ ...params, tas: valueproccesed, numtas: value });
    };
    const handleFC = (value) => {
      let valueproccesed = 0;
      if (value > 0 && value < 50) {
        valueproccesed = 1;
      } else if (value >= 50) {
        valueproccesed = 2;
      }
      setParams({ ...params, fc: valueproccesed, numfc: value });
    };
    const handleTFG = (value) => {
      let valueproccesed = 0;
      if (value > 0 && value < 20) {
        valueproccesed = 1;
      } else if (value >= 20 && value < 30) {
        valueproccesed = 2;
      } else if (value >= 30) {
        valueproccesed = 3;
      }
      setParams({ ...params, tfg: valueproccesed, numtfg: value });
    };
    const handleK = (value) => {
      let valueproccesed = 0;
      if (value > 0 && value < 5.5) {
        valueproccesed = 1;
      } else if (value >= 5.5) {
        valueproccesed = 2;
      }
      setParams({ ...params, k: valueproccesed, numk: value });
    };
    return (
        <IonPage>
            <IonContent className="IonPadding" fullscreen="true" >
            <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle className='headertitle' style={{ fontSize: "24"}}>{props.literales.otrostextos.iccronica}
                    </IonTitle>
                </IonToolbar>
                <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">
                    <IonRow key="fila1" className='paddingh20 pt2 noprint'><IonCol size="12">
                        <IonText className="f1 mx2 pt2">{props.literales.otrostextos.indiquefe}</IonText>
                    </IonCol>
                    </IonRow>
                    <IonRow key="fila2" className='paddingh20 noprint'>
                        <IonCol size="12">
                            <ControlFE hideparams={0} handler={handleFE} description={props.literales.otrostextos.fe_desc}  desconocida={props.literales.otrostextos.desconocida} title={props.literales.otrostextos.fe}  name="fe" min={10} max={79} step={1} defaultValue={40} ></ControlFE>
                        </IonCol>
                    </IonRow>
                    <IonRow key="fila3" className='paddingh20 pt2 noprint'>
                        <IonCol size="12">
                            <IonText className="f1 mx2 pt2">{hideparams === 1 ? props.literales.otrostextos.indiquetas : props.literales.otrostextos.indiqueall}</IonText>
                        </IonCol>
                    </IonRow>
                    <IonRow key="fila4" className='paddingh20 noprint'>
                        <IonCol size="6">
                            <Control hideparams={0} handler={handleTAS} title={props.literales.otrostextos.tas} description={props.literales.otrostextos.tas_desc} name="tas" min={50} max={199} step={1} defaultValue={120} ></Control>
                        </IonCol>
                        <IonCol size="6">
                            <Control hideparams={hideparams} handler={handleFC} title={props.literales.otrostextos.fc} description={props.literales.otrostextos.fc_desc} name="fc" min={40} max={120} step={1} defaultValue={80}></Control>
                        </IonCol>
                    </IonRow><IonRow  key="fila5" className='paddingh20 noprint'>
                        <IonCol size="6">
                            <Control hideparams={hideparams} handler={handleTFG} title={props.literales.otrostextos.tfg} description={props.literales.otrostextos.tfg_desc} name="tfg" min={15} max={120} step={1} defaultValue={50}></Control>
                        </IonCol>
                        <IonCol size="6">
                            <Control hideparams={hideparams} handler={handleK} title={props.literales.otrostextos.k} description={props.literales.otrostextos.k_desc} name="k" min={3.5} max={6} step={0.1} defaultValue={5}></Control>
                        </IonCol>
                    </IonRow>
                    {result > 0 && <Resultado literales={props.literales} result={result} params={params} />}
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Calculo;
